import { render, staticRenderFns } from "./LatestMessageCard.vue?vue&type=template&id=8378b7b4&scoped=true&"
import script from "./LatestMessageCard.vue?vue&type=script&lang=js&"
export * from "./LatestMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./LatestMessageCard.vue?vue&type=style&index=0&id=8378b7b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8378b7b4",
  null
  
)

export default component.exports